<template>
  <a-select
    :value="currentLocale"
    class="NavBarSwitcher LanguageSwitcher"
    :class="{
      'NavBarSwitcher--sub': currentLocale !== defaultLocale,
      'NavBarSwitcher--light': theme === 'light'
    }"
    dropdown-class-name="NavBarSwitcherDropdown"
    @change="updateLocale($event)"
  >
    <a-select-option
      v-for="locale in options"
      :key="locale.value"
      :value="locale.value"
    >
      <img
        width="16"
        :src="locale.icon"
      >
    </a-select-option>
  </a-select>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import { useI18n, locales, defaultLocale } from '@/composables/useI18n'
import type { Locale } from '@/composables/useI18n'

export default defineComponent({
  name: 'LangSwitcher',

  props: {
    value: {
      type: String,
      default: 'nl',
      validator: val => val && locales.includes(val)
    },
    theme: {
      type: String,
      default: 'dark',
      validator: val => ['dark', 'light'].includes(val)
    }
  },

  setup() {
    const { currentLocale, updateLocale } = useI18n()
    const options = locales.map((l: Locale) => ({
      icon:
        require(`../assets/images/flags/${l}.svg`),
      value: l
    }))

    return {
      defaultLocale,
      currentLocale,
      updateLocale,
      options
    }
  }
})
</script>

<style>
.NavBarSwitcher.LanguageSwitcher .ant-select-selection--single .ant-select-selection__rendered {
  margin-right: 4px;
  margin-left: 0;
}
</style>